import { Route } from 'react-router-dom'

// Layout
import BusinessCashierLayout from '../layout/BusinessCashierLayout'

// Pages
import BusinessDashboardPage from '../pages/business/BusinessDashboardPage'
import SettingsPage from '../pages/business/SettingsPage'

// Guards
import ProtectedRoute from '../core/guards/ProtectedRoute'
import { AppRoute } from '../core/config/app-routes'
import MenuManagementPage from '@/pages/business/MenuManagementPage'

export default function BusinessCashierRoutes() {
  return (
    <>
      <Route
        path={AppRoute.BUSINESS_CASHIER_DASHBOARD_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessCashierLayout>
              <BusinessDashboardPage />
            </BusinessCashierLayout>
          </ProtectedRoute>
        }
      />

      {/* Menu Management */}
      <Route
        path={AppRoute.BUSINESS_CASHIER_MENU_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessCashierLayout>
              <MenuManagementPage />
            </BusinessCashierLayout>
          </ProtectedRoute>
        }
      />

      {/* Settings */}
      <Route
        path={AppRoute.BUSINESS_CASHIER_SETTINGS_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessCashierLayout>
              <SettingsPage />
            </BusinessCashierLayout>
          </ProtectedRoute>
        }
      />
    </>
  )
}
